import JobDetail from "../../components/customer/jobs/job-detail";

const JobDetailPage = () => {
  return <JobDetail />;
};

export default JobDetailPage;

